import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, PropType, ref, watch } from "vue";
import { getEntityTranslation } from "@/helpers";
import _ from "lodash";
import { CompanyRoleDto } from "@api/company-role-dto";
import publicFormApi from "@/publicFormApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyRoleField',
  props: {
	modelValue: {
		type: Array as PropType<CompanyRoleDto[] | null>,
		required: true,
	},
},
  emits: ["update:modelValue", "blur"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const companyRoles = ref([] as CompanyRoleDto[]);
const selectedCompanyRoleIds = ref([] as number[]);
if (props.modelValue) {
	selectedCompanyRoleIds.value = props.modelValue.map((r) => r.id!);
}

const getCompanyRoles = async () => {
	const resp = await publicFormApi.call.companyForm.get.companyRoles();
	if (resp.isSuccessful && resp.data) {
		companyRoles.value = _.cloneDeep(resp.data);
	}
};
getCompanyRoles();
watch(
	selectedCompanyRoleIds,
	(newVal) => {
		if (!Array.isArray(newVal)) return;
		cModelValue.value = companyRoles.value.filter((r) => newVal.includes(r.id!));
	},
	{ deep: true }
);

const cModelValue = computed<CompanyRoleDto[]>({
	get() {
		return props.modelValue as CompanyRoleDto[];
	},
	set(newVal: CompanyRoleDto[]) {
		emit("update:modelValue", newVal);
	},
});

return (_ctx: any,_cache: any) => {
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (companyRoles.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(companyRoles.value, (role) => {
          return (_openBlock(), _createBlock(_component_HakoCheckbox, {
            key: role.id!,
            modelValue: selectedCompanyRoleIds.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCompanyRoleIds).value = $event)),
            value: role.id,
            inline: "",
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getEntityTranslation)(role.translations, "name")), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "value"]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})